


















import Vue from "vue";

import { Carousel, Slide } from "vue-carousel";
import { Image } from "../store/state";

export default Vue.extend<{}, {}, {}, {}>({
  name: "Slideshow",
  components: {
    Carousel,
    Slide
  },

  computed: {
    getImages() {
      return this.$store.state.images;
    }
  }
});
